"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=13%3A587))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:28.224Z
 */
export const Australia = createSVGIcon(
  <>
    <rect x="1" y="1" width="16" height="12" fill="#354992" />
    <path
      d="M14 9L14.2939 9.59549L14.9511 9.69098L14.4755 10.1545L14.5878 10.809L14 10.5L13.4122 10.809L13.5245 10.1545L13.0489 9.69098L13.7061 9.59549L14 9Z"
      fill="white"
    />
    <path
      d="M9 9L9.29389 9.59549L9.95106 9.69098L9.47553 10.1545L9.58779 10.809L9 10.5L8.41221 10.809L8.52447 10.1545L8.04894 9.69098L8.70611 9.59549L9 9Z"
      fill="white"
    />
    <path
      d="M12 8L12.2939 8.59549L12.9511 8.69098L12.4755 9.15451L12.5878 9.80902L12 9.5L11.4122 9.80902L11.5245 9.15451L11.0489 8.69098L11.7061 8.59549L12 8Z"
      fill="white"
    />
    <path
      d="M14 6L14.2939 6.59549L14.9511 6.69098L14.4755 7.15451L14.5878 7.80902L14 7.5L13.4122 7.80902L13.5245 7.15451L13.0489 6.69098L13.7061 6.59549L14 6Z"
      fill="white"
    />
    <path
      d="M14 3L14.2939 3.59549L14.9511 3.69098L14.4755 4.15451L14.5878 4.80902L14 4.5L13.4122 4.80902L13.5245 4.15451L13.0489 3.69098L13.7061 3.59549L14 3Z"
      fill="white"
    />
    <rect x="4" y="1" width="4" height="8" fill="white" />
    <rect x="1" y="3" width="10" height="4" fill="white" />
    <rect x="5" y="1" width="2" height="8" fill="#B64343" />
    <rect
      x="11"
      y="4"
      width="2"
      height="10"
      transform="rotate(90 11 4)"
      fill="#B64343"
    />
    <rect x="1" y="1" width="16" height="12" stroke="#757575" />
  </>,
  "Australia",
  (strictLocalize) => ({
    viewBox: "0 0 18 14",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Australia flag",
      description: { text: "The label for the Australia flag icon" },
    }),
  })
);
